import type { RecordSourceSelectorProxy } from 'relay-runtime';
import type {
	EditViewAppearanceProps,
	EditViewSelectProps,
} from '@atlassian/jira-issue-field-edit-view-common/src/common/types.tsx';
import type { FieldInlineEditLiteConsumerProps } from '@atlassian/jira-issue-field-inline-edit-lite/src/common/types.tsx';
import type { atlasProject_issueFieldAtlasProjectInlineEditFull_AtlasProjectInlineEditView_fragmentRef$key as AtlasProjectFragment } from './__generated__/atlasProject_issueFieldAtlasProjectInlineEditFull_AtlasProjectInlineEditView_fragmentRef.graphql';
import type { atlasProject_issueFieldAtlasProjectInlineEditFull_AtlasProjectInlineEditViewWithIsEditable_fragmentRef$key as AtlasProjectWithIsEditableFragment } from './__generated__/atlasProject_issueFieldAtlasProjectInlineEditFull_AtlasProjectInlineEditViewWithIsEditable_fragmentRef.graphql';

export type LinkedProject = {
	id: string;
	name: string;
	key: string;
	isPrivate: boolean;
};
export interface AtlasProjectInlineEditBaseProps
	extends FieldInlineEditLiteConsumerProps,
		EditViewAppearanceProps,
		EditViewSelectProps {
	/**
	 * Sets whether the component shows the `readView` or the `editView`. This is used to manage
	 * the state of the input in stateless inline edit.
	 */
	isEditing?: boolean;
	/** Callback triggered when a mutation is initially requested and optimistically rendered */
	onSubmit?: (value: LinkedProject | null) => void;
	/** Callback triggered when a mutation errors */
	onSubmitFailed?: () => void;
	/** Callback triggered when a mutation is successful and confirmed */
	onSubmitSucceeded?: (value: LinkedProject | null) => void;
}

/** Props for \<[AtlasProjectInlineEditView](./index.tsx) /> */
export interface AtlasProjectInlineEditViewProps extends AtlasProjectInlineEditBaseProps {
	/** this is a reference to the relay fragment of AtlasProjectFragment type */
	fragmentRef: AtlasProjectFragment;
}

/** Props for \<[AtlasProjectInlineEditViewWithIsEditable](./index.tsx) /> */
export interface AtlasProjectInlineEditViewWithIsEditableProps
	extends AtlasProjectInlineEditBaseProps {
	/** this is a reference to the relay fragment of AtlasProjectWithIsEditableFragment type */
	fragmentRef: AtlasProjectWithIsEditableFragment;
	/**
	 * When `true` the user will be able to edit the field value. When `false` the field will be displayed in a
	 * read-only mode.
	 * */
	isEditable: boolean;
	/**
	 * this is for the popup position in editView
	 * default is bottom-end
	 * */
	popupPlacement?: 'bottom-start' | 'bottom-end';
}

/** Link mutation error types that have specific handling implemented */
export const LINK_MUTATION_ERROR_TYPES = {
	CHILD_ITEMS_LINKED_TO_ANOTHER_PROJECT: 'CHILD_ITEMS_LINKED_TO_ANOTHER_PROJECT',
} as const;
export type LinkMutationErrorType =
	(typeof LINK_MUTATION_ERROR_TYPES)[keyof typeof LINK_MUTATION_ERROR_TYPES];

export type HandleMutationErrorProps = {
	errorType?: string | null;
	canReplace?: boolean | null;
	onFail: () => void;
	onFireAnalyticsEvent: () => void;
};

export type UpdaterProps = {
	store: RecordSourceSelectorProxy;
	projectId: string;
	value: LinkedProject | null;
	mutation: 'link' | 'unlink';
};
